import { useNavigate } from 'react-router-dom';
import { useUserContext } from '@context/UserContext';
import { useCustomObjectFields } from '@hooks/useCustomObjectsFields';

export function useNewUser() {
    const navigate = useNavigate();
    const { selectedRole, setSelectedRole } = useUserContext();
    const { availableRoles } = useCustomObjectFields();


    const handleAddAccount = () => {
        if (!selectedRole) return;
        navigate('/add-account');
    };


    return {
        availableRoles,
        selectedRole,
        setSelectedRole,
        handleAddAccount,
    };
}